export default __webpack_public_path__ + "7889be6a9c89da7f924d07c4e3bd924d.svg";